import { storyblokEditable } from "gatsby-source-storyblok"

import EcoSystemIntroCard from "../../../../V2/Cards/EcoSystem/Intro"

import { storyblokLinkToYocoLink } from "@utils/storyblok"
import React from "react"

const StoryblokEcoSystemIntroCard = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.EcoSystemIntroCard>) => {
  return (
    <EcoSystemIntroCard
      backgroundColor={blok.backgroundColor}
      titleText={blok.titleText}
      titleSize={blok.titleSize}
      subTitleText={blok.subTitleText}
      bodyHeader={blok.bodyHeader}
      priceBadge={blok.priceBadge?.[0]}
      descriptionText={blok.descriptionText}
      iconUrl={blok.icon?.filename}
      iconAlt={blok.icon?.alt}
      size={blok.size}
      buttonText={blok.size === "large" && blok?.ctaText ? blok.ctaText : ""}
      buttonLink={
        blok.size === "large"
          ? storyblokLinkToYocoLink(blok.ctaLink)
          : undefined
      }
      tags={blok.tags}
      mobileGridOrder={mobileGridOrder}
      trackingEvent={blok.trackingEvent}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokEcoSystemIntroCard
